/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UpdateCrashLinkRequest interface.
 */
export function instanceOfUpdateCrashLinkRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function UpdateCrashLinkRequestFromJSON(json) {
    return UpdateCrashLinkRequestFromJSONTyped(json, false);
}
export function UpdateCrashLinkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'openDataCrashId': !exists(json, 'openDataCrashId') ? undefined : json['openDataCrashId'],
    };
}
export function UpdateCrashLinkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'openDataCrashId': value.openDataCrashId,
    };
}
